{
  "invite": {
    "subjectCrew": "Opti-Sea: your access to {{vessel}}",
    "subjectOffice": "Opti-Sea: office access for {{company}}",
    "greeting": "Hello {{name}},",
    "crewBody": "{{inviter}} gave you access to {{vessel}} as {{position}} in Opti-Sea, the app that helps the crew prepare for the RISQ inspection.",
    "officeBody": "{{inviter}} gave you office access for {{company}} in the Opti-Sea dashboard.",
    "stepsTitle": "How to start:",
    "crewInstall": "Install the Opti-Sea app on your phone.",
    "crewInstallLater": "Your office will send you the link to install the app.",
    "crewIos": "iPhone: {{url}}",
    "crewAndroid": "Android: {{url}}",
    "crewOpen": "Open the app and tap \"Sign in\".",
    "crewEmail": "Enter this email address: {{email}}. We send you a 6-digit code by email; type it in the app.",
    "crewOffline": "The app downloads your questions once (internet needed). After that it works without internet.",
    "officeOpen": "Open {{url}} in your browser.",
    "officeEmail": "Enter this email address: {{email}} and type the 6-digit code we send you by email.",
    "ignore": "If you did not expect this email, you can ignore it."
  }
}
